import React from 'react';
import moonImg from '../assets/moon-logo-transparent.png';

/**
 * Animated moon logo that matches the title's color shimmer.
 * - The moon shape uses the PNG as a CSS mask so we can tint it.
 * - A same-rhythm color animation (luna-logo-hue) shifts the tint through
 *   the same purple/pink palette used by the title.
 * - Two small purple dots (top/bottom) twinkle in sync.
 */
export default function MoonLogo({ size = 58 }) {
  return (
    <span
      className="luna-moon-wrap"
      style={{ width: size, height: size }}
      aria-label="Luna logo"
      role="img"
    >
      <span
        className="luna-moon-shape"
        style={{
          WebkitMaskImage: `url(${moonImg})`,
          maskImage: `url(${moonImg})`
        }}
      />
      <span className="luna-moon-dot top" />
      <span className="luna-moon-dot bottom" />
    </span>
  );
}
